import {css} from 'lit';
export const styles = css`:host {
  position: relative;
  display: grid;
  grid-template-columns: -webkit-min-content auto -webkit-min-content;
  grid-template-columns: min-content auto min-content;
  grid-template-rows: -webkit-min-content;
  grid-template-rows: min-content;
  grid-gap: 16px 8px;
  padding: 4px;
  border-radius: 4px;
  background-color: var(--contrast-light);
  font-size: 14px;
}

.title {
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.2;
  flex: 1 1 auto;
  font-size: 1.2em;
  word-wrap: anywhere;
}

.info {
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.2;
  margin-top: 4px;
  color: var(--dark-text-secondary);
  word-wrap: anywhere;
}

@media (max-width: 991px) {
  :host slot[name='left'],
  slot[name='right'] {
    white-space: nowrap;
  }
}

slot[name='left'] {
  display: flex;
  margin: -8px -4px;
}

slot[name='left']::slotted(*) {
  margin: 8px 4px;
}

slot[name='right'] {
  display: flex;
  margin: -8px -4px;
}

slot[name='right']::slotted(*) {
  margin: 8px 4px;
}

:host([info]) .title {
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.2;
}

:host([name]) slot[name='main']::slotted(*) {
  margin-top: 4px;
}

:host(.slot-left-empty) {
  grid-template-columns: auto -webkit-min-content;
  grid-template-columns: auto min-content;
}

:host(.slot-left-empty) slot[name='left'] {
  display: none;
}

:host(.slot-right-empty) {
  grid-template-columns: -webkit-min-content auto;
  grid-template-columns: min-content auto;
}

:host(.slot-right-empty) slot[name='right'] {
  display: none;
}

:host(.slot-left-empty.slot-right-empty) {
  display: block;
}

@media (max-width: 767px) {
  :host([BreakFirstXs].slot-right-empty) {
    display: block;
  }

  :host([BreakFirstXs].slot-right-empty) main {
    margin-top: 16px;
  }
}

@media (max-width: 767px) {
  :host([BreakLastXs].slot-left-empty) {
    display: block;
  }

  :host([BreakLastXs].slot-left-empty) main {
    margin-bottom: 16px;
  }
}

@media (max-width: 767px) {
  :host([BreakLastXs]) {
    grid-template-columns: -webkit-min-content auto;
    grid-template-columns: min-content auto;
  }
}

@media (max-width: 767px) {
  :host([BreakLastXs]) slot[name='right'] {
    grid-column: 1/3;
  }
}

@media (max-width: 767px) {
  :host([BreakFirstXs]) {
    grid-template-columns: auto -webkit-min-content;
    grid-template-columns: auto min-content;
  }
}

@media (max-width: 767px) {
  :host([BreakFirstXs]) slot[name='left'] {
    grid-column: 1/3;
  }
}

:host([alignh='top']) {
  align-items: flex-start;
}

:host([alignh='center']) {
  align-items: center;
}

:host([alignh='end']) {
  align-items: flex-end;
}
`;
export default styles;
